<template>
  <div class="area-definition-monitoring-groups-description">
    <label>{{ label }}</label>
    <div
        v-for="value in cluster"
        :key="value.id"
        class="mb-3"
    >
      <div class="row">
        <div class="col-12 col-md-2 font-weight-bold">
          <h4>{{ value.name }}</h4>
        </div>

        <div class="col-12 col-md-10">
          <h4>{{ formatMinMax(value) }}</h4>
        </div>
      </div>

      <div
          v-if="value.number_groups"
          class="row"
      >
        <div class="col-12 col-md-2 font-weight-bold">
          {{ numberGroupsLabel }}:
        </div>

        <div class="col-12 col-md-10">
          <a href="#" @click.prevent="toggleCollapse(value.id)">
            {{ expandLabel }}
            <i
                class="fa"
                :class="isOpen(value.id) ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
          </a>

          <div v-show="isOpen(value.id)" class="card card-body mt-2">
            <div
                v-for="(group, index) in splitGroups(value.number_groups)"
                :key="index"
            >
              {{ group }}
            </div>
          </div>
        </div>
      </div>

      <div class="row border-bottom pb-2">
        <div class="col-12 col-md-4 font-weight-bold">
          {{ excludeFromAllFriendsLabel }}:
        </div>

        <div class="col-12 col-md-8">
          {{ value.exclude_from_all_friends ? yesLabel : noLabel }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-2">
        <h4>New Friends:</h4>
      </div>
      <div class="col-12 col-md-10" v-html="newFriendsDescription"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonitoringGroupOverview',

  props: {
    cluster: {
      type: [Array, Object, null],
      default: null
    },
    numberGroupsLabel: {
      type: String,
      default: ''
    },
    expandLabel: {
      type: String,
      default: 'Expand'
    },
    excludeFromAllFriendsLabel: {
      type: String,
      default: ''
    },
    yesLabel: {
      type: String,
      default: 'ja'
    },
    noLabel: {
      type: String,
      default: 'nein'
    },
    label: {
      type: String,
      default: ''
    },
    newFriendsDescription: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      openItems: []
    }
  },

  computed: {
  },

  methods: {
    formatMinMax(value) {
      if (value.minimum_value == null && value.maximum_value == null) {
        return '-'
      }

      if (value.maximum_value == null) {
        return value.minimum_value
      }

      if (value.minimum_value == null) {
        return value.maximum_value
      }

      return `${value.minimum_value}, ${value.maximum_value}`
    },

    splitGroups(numberGroups) {
      return String(numberGroups)
          .split(',')
          .map(item => item.trim())
          .filter(Boolean)
    },

    toggleCollapse(id) {
      if (this.openItems.includes(id)) {
        this.openItems = this.openItems.filter(item => item !== id)
      } else {
        this.openItems.push(id)
      }
    },

    isOpen(id) {
      return this.openItems.includes(id)
    }
  }
}
</script>